const NEW_CONNECTION_STEPS = {
  0: "Documents Uploading",
  1: "Documents Verification",
  2: "Arrear Verification",
  3: "Field Survey",
  4: "Reference No. Allocation",
  5: "Demand Note Payment",
  6: "DN Payment Verification",
  7: "Service Connection Order",
  8: "Meter Installation",
  9: "Ready for Billing",
  10: "Completed",
  21: "Wiring Test Report",
};

const MCO_STEPS = {
  0: "Documents Uploading",
  1: "Documents Verification",
  2: "Approval / Rejection",
  3: "Arrear Verification",
  4: "Field Survey",
  5: "M&T Report",
  6: "DN Approval",
  7: "DN Submission",
  8: "DN Payment Verification",
  9: "Meter Installation",
  10: "Forward To RO",
  11: "Ready for Billing",
  12: "Completed",
};

const COA_STEPS = {
  0: "Documents Uploading",
  1: "Documents Verification",
  2: "Wiring Test Report",
  3: "Arrear Verification",
  4: "Field Survey",
  5: "DN Approval",
  6: "DN Submission",
  7: "DN Payment Verification",
  8: "Sundary Jobs Order",
  9: "Ready for Billing",
  10: "Completed",
};

const RECONNECTION_STEPS = {
  0: "Documents Uploading",
  1: "Documents Verification",
  2: "RCO Fee Approval",
  3: "RCO Fee Submission",
  4: "RCO Fee Verification",
  5: "Field Survey",
  6: "DN Approval",
  7: "DN Submission",
  8: "DN Payment Verification",
  9: "Meter Installation",
  10: "Forward To RO",
  11: "Ready for Billing",
  12: "Completed",
};

const CHANGE_OF_LOAD_TARIFF_STEPS = {
  0: "Document Submission",
  1: "Document Verification",
  2: "Arrear Verification",
  3: "Site Survey",
  4: "DN Payment Submission",
  5: "DN Payment Verification",
  6: "Service Job Order",
  7: "SCO Execution",
  8: "Ready for Billing",
  9: "Completed",
};

const INSTALLMENT_DUE_DATE_STEPS = {
  0: "Documents Uploading",
  1: "Documents Verification",
  2: "Arrears Verification",
  3: "Field Verification",
  4: "Demand Note Issued",
  5: "DN Payment Verification",
  6: "Meter Installation",
  7: "Ready for Billing",
};

const SIMPLE_DOC_STEPS = {
  0: "Documents Uploading",
  1: "Documents Verification",
};

const ADVANCE_PAYMENT_STEPS = {
  0: "Application Submission",
  1: "Document Verification",
  2: "Process Advance Payment",
  3: "Completed",
};

const MRC_STEPS = {
  0: "Application Submitted",
  1: "Document Verification",
  2: "Authority Verification",
  3: "Site Survey",
  4: "Forward for Billing",
  5: "Post for Billing",
  6: "Completed",
};

const WITHDRAWAL_OF_INSTALLMENT_STEPS = {
  [-1]: "Request Declined",
  0: "Application Submitted",
  1: "Completed",
};

const STEPS_BY_APPLICATION_TYPE = {
  1: NEW_CONNECTION_STEPS,
  2: MCO_STEPS,
  4: CHANGE_OF_LOAD_TARIFF_STEPS,
  5: MCO_STEPS,
  6: CHANGE_OF_LOAD_TARIFF_STEPS,
  7: INSTALLMENT_DUE_DATE_STEPS,
  8: INSTALLMENT_DUE_DATE_STEPS,
  11: MRC_STEPS,
  13: RECONNECTION_STEPS,
  15: COA_STEPS,
  16: SIMPLE_DOC_STEPS,
  17: SIMPLE_DOC_STEPS,
  18: ADVANCE_PAYMENT_STEPS,
  19: WITHDRAWAL_OF_INSTALLMENT_STEPS,
};

const resolveStepsByTypeName = (typeName) => {
  const name = String(typeName || "").toLowerCase();
  if (!name) return null;

  if (name.includes("meter reading correction")) return MRC_STEPS;
  if (name.includes("meter change")) return MCO_STEPS;
  if (name.includes("new connection")) return NEW_CONNECTION_STEPS;
  if (name.includes("reconnection")) return RECONNECTION_STEPS;
  if (name.includes("change of attribute") || name.includes("attributes")) return COA_STEPS;
  if (name.includes("change of load") || name.includes("change of tariff")) {
    return CHANGE_OF_LOAD_TARIFF_STEPS;
  }
  if (name.includes("withdrawal of installment")) return WITHDRAWAL_OF_INSTALLMENT_STEPS;
  if (name.includes("installment") || name.includes("due date")) {
    return INSTALLMENT_DUE_DATE_STEPS;
  }
  if (name.includes("advance payment")) return ADVANCE_PAYMENT_STEPS;
  return null;
};

export const getApplicationProgressStatus = (
  applicationTypeId,
  applicationProgressId,
  objectionStatus,
  fallbackStatus = "-",
  applicationTypeName = "",
) => {
  const typeId = Number(applicationTypeId);
  if (
    applicationProgressId === null ||
    applicationProgressId === undefined ||
    applicationProgressId === ""
  ) {
    return fallbackStatus || "-";
  }

  const progressId = Number(applicationProgressId);
  const steps = STEPS_BY_APPLICATION_TYPE[typeId] || resolveStepsByTypeName(applicationTypeName);

  if (!steps || Number.isNaN(progressId)) {
    return fallbackStatus || "-";
  }

  const stepName = steps[progressId];
  if (!stepName) {
    return fallbackStatus || "-";
  }

  if (Number(objectionStatus) === 1) {
    return `${stepName} (Objection)`;
  }

  return stepName;
};
